import { resolveInventoryDisplayQty } from '#/modules/imsMgmt/inventoryStock/helper/displayInventoryQty';

/**
 * Safety Check `display.{safetyQty|availableQty|shortageQty}` 是單位 metadata＋基礎量（非已換算數字），
 * 與 Inventory Stock `qty` 同形，沿用同一套換算（小數三位 HALF_UP）。
 * 不讀頂層 safetyQty／availableQty／shortageQty 換算；三欄各自用自己的 metadata。
 *
 * @param {object} row safety-check list item（camelCase）
 * @param {'safetyQty'|'availableQty'|'shortageQty'} key
 * @returns {string}
 */
export function formatSafetyCheckQty(row, key) {
  const member = row?.display?.[key];
  const display = resolveInventoryDisplayQty({ qty: member });
  if (!display || display.text == null) {
    return '-';
  }
  return display.unitName ? `${display.text} ${display.unitName}` : display.text;
}
